import { HttpErrorResponse } from "@angular/common/http";

export interface ImportExternalResultsState {
  uploadLoader: boolean;
  uploadResult: boolean;
  uploadError: HttpErrorResponse;

  statusLoader: boolean;
  statusResult: ImportExternalResultsStatus; 
  statusError: HttpErrorResponse;

  authSSELoader: boolean;
  authSSEResult: boolean;
  authSSEError: HttpErrorResponse;

  errorListFile: string[];
  errorListLoader: boolean;
  errorListError: HttpErrorResponse;

  hasImportLoader: boolean;
  hasImportResult: number;
  hasImportError: HttpErrorResponse;

  cancelImportLoader: boolean;
  cancelImportResult: boolean | null;

  clearSessionLoader: boolean;
}

export interface ImportExternalResultsStatus {
  Completed: number,
  Failed: number,
  Total: number,
  LineError: LineError[],
  Errors: []
  Cancelled: boolean;
}

export interface LineError {
  line: number;
  message: string;
}

export const initialImportExternalResultsState: ImportExternalResultsState = {
  uploadLoader: false,
  uploadResult: null,
  uploadError: null,

  statusLoader: false,
  statusResult: null,
  statusError: null,

  authSSELoader: false,
  authSSEResult: false,
  authSSEError: null,

  errorListFile: [],
  errorListLoader: false,
  errorListError: null,

  hasImportLoader: false,
  hasImportResult: 0,
  hasImportError: null,

  cancelImportLoader: false,
  cancelImportResult: null,

  clearSessionLoader: false,
}